module.exports = __webpack_public_path__ + "static/media/helpbg.31b75e9.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/helpbg.webm
// module id = Bw/A
// module chunks = 0